import { Injectable } from '@angular/core';

import { map } from 'rxjs/operators';

import { RouterReducerState } from '@ngrx/router-store';
import { select, Store } from '@ngrx/store';

import { RouterStateUrl } from '@sd-portal/shared/util';

import { State } from '..';
import * as actions from './expense.actions';
import * as fromExpenseQuery from './expense.selectors';

@Injectable()
export class ExpenseFacade {
  expenseSkeletonLoading$ = this.store.pipe(select(fromExpenseQuery.getExpenseSkeletonLoading));
  expenseSkeletonLoaded$ = this.store.pipe(select(fromExpenseQuery.getExpenseSkeletonLoaded));
  expenseSkeleton$ = this.store.pipe(select(fromExpenseQuery.getExpenseSkeleton));

  deletedExpenseSkeletonsLoading$ = this.store.pipe(
    select(fromExpenseQuery.getDeletedExpenseSkeletonsLoading)
  );
  deletedExpenseSkeletonsLoaded$ = this.store.pipe(
    select(fromExpenseQuery.getDeletedExpenseSkeletonsLoaded)
  );
  deletedExpenseSkeletons$ = this.store.pipe(select(fromExpenseQuery.getDeletedExpenseSkeletons));

  expenseAuditLoading$ = this.store.pipe(select(fromExpenseQuery.getExpenseAuditLoading));
  expenseAuditLoaded$ = this.store.pipe(select(fromExpenseQuery.getExpenseAuditLoaded));
  expenseAudit$ = this.store.pipe(select(fromExpenseQuery.getExpenseAudit));

  constructor(
    private readonly store: Store<{
      router: RouterReducerState<RouterStateUrl>;
      sharedAudit: State;
    }>
  ) {}

  loadExpense() {
    this.store.dispatch(actions.ResetExpense());
    this.store.dispatch(actions.LoadExpenseCategoryTypes());
    this.store.dispatch(actions.LoadExpenseSkeleton());
  }

  loadDeletedExpenses() {
    this.store.dispatch(actions.ResetExpense());
    this.store.dispatch(actions.LoadExpenseCategoryTypes());
    this.store.dispatch(actions.LoadDeletedExpenseSkeletons());
  }

  getExpenseCategoryTypeName(expenseCategoryTypeId: number) {
    return this.store.pipe(
      select(fromExpenseQuery.getExpenseCategoryTypeName(expenseCategoryTypeId)),
      map(r => (r ? r.name : ''))
    );
  }

  loadExpenseAudit(expenseId: number) {
    this.store.dispatch(actions.LoadExpenseAudit({ expenseId }));
  }

  loadNextPageExpenseAudit(expenseId: number) {
    this.store.dispatch(actions.LoadNextPageExpenseAudit({ expenseId }));
  }
}
